import React from 'react';
import { graphql } from 'react-apollo';
import { flowRight as compose } from 'lodash';
import withStyles from 'isomorphic-style-loader/withStyles';
import { FormattedMessage } from 'react-intl';
import cx from 'classnames';

import s from './Location.css';
import messages from '../../../locale/messages';
import Loader from '../../../components/Common/Loader/Loader';
import LocationList from '../../../components/SiteAdmin/Location/LocationList/LocationList';
import getAllLocationsAdminQuery from './getAllLocationsAdmin.graphql';

class Location extends React.Component {
    render() {
        const { title, locationDetails, locationDetails: { loading } } = this.props;
        return (
            <Loader type={"page"} show={loading}>
                <div>
                    <div className={cx('heading', 'textAlignRightRTL')}>
                        <FormattedMessage {...messages.manageLocationHeading} />
                    </div>
                    <div>
                        {!loading && <LocationList locationDetails={locationDetails} />}
                    </div>
                </div>
            </Loader>
        );
    }
}

export default compose(
    withStyles(s),
    graphql(getAllLocationsAdminQuery, {
        name: 'locationDetails',
        options: {
            ssr: true,
            fetchPolicy: 'network-only',
            variables: { currentPage: 1, searchList: '' },
        },
    })
)(Location);
